/* 🤖 this file was generated by svg-to-ts */
export const matIconCastConnected: {
  name: 'cast-connected';
  data: string;
} = {
  name: 'cast-connected',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 0 1 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 7v2h12v6h-3v2h5V7z"/></svg>`
};
